import IPModal from './IPModal'

export default IPModal
